import { SundaeSDK } from "@sundaeswap/sdk-core";
import { Dispatch } from "react";
import { EAppActions, EPoolTableSortingOptions, ESortingDirection, IAppAction } from "./types";

type TActionFunc<T> = (value: T, dispatch: Dispatch<IAppAction>) => void;

/* -------------------------------------------------------------------------------------------------
 * App
 * -----------------------------------------------------------------------------------------------*/
const setErrorReporting: TActionFunc<boolean> = (errorReportingEnabled, dispatch) =>
  dispatch({ type: EAppActions.SET_ERROR_REPORTING, payload: { errorReportingEnabled } });

const setConnectWalletOpen: TActionFunc<boolean> = (walletConnectOpen, dispatch) =>
  dispatch({ type: EAppActions.CONNECT_WALLET_OPEN, payload: { walletConnectOpen } });

const setOffCanvasOpen: TActionFunc<boolean> = (offCanvasOpen, dispatch) =>
  dispatch({ type: EAppActions.SET_OFFCANVAS_OPEN, payload: { offCanvasOpen } });

const setChooseHandleOpen: TActionFunc<boolean> = (chooseHandleOpen, dispatch) =>
  dispatch({ type: EAppActions.SET_CHOOSE_HANDLE_OPEN, payload: { chooseHandleOpen } });

const setChooseAvatarOpen: TActionFunc<boolean> = (chooseAvatarOpen, dispatch) =>
  dispatch({ type: EAppActions.SET_CHOOSE_AVATAR_OPEN, payload: { chooseAvatarOpen } });

const setWrongNetworkOpen: TActionFunc<boolean> = (wrongNetworkOpen, dispatch) =>
  dispatch({ type: EAppActions.SET_WRONG_NETWORK_OPEN, payload: { wrongNetworkOpen } });

const setPoolsSortingDirection: TActionFunc<ESortingDirection> = (
  sortPoolsSortingDirection,
  dispatch
) =>
  dispatch({
    type: EAppActions.SET_POOLS_SORTING_DIRECTION,
    payload: { sortPoolsSortingDirection },
  });

const setSDK: TActionFunc<SundaeSDK> = (sdk, dispatch) =>
  dispatch({ type: EAppActions.SET_SDK, payload: { sdk } });

const setSortPoolsBy: TActionFunc<EPoolTableSortingOptions> = (sortPoolsBy, dispatch) =>
  dispatch({ type: EAppActions.SET_POOLS_SORT_BY, payload: { sortPoolsBy } });

const setZapOpen: TActionFunc<boolean> = (zapOpen, dispatch) =>
  dispatch({ type: EAppActions.SET_ZAP_OPEN, payload: { zapOpen } });

/* -------------------------------------------------------------------------------------------------
 * Export
 * -----------------------------------------------------------------------------------------------*/
export const Actions = {
  setSDK,
  setErrorReporting,
  setConnectWalletOpen,
  setOffCanvasOpen,
  setPoolsSortingDirection,
  setSortPoolsBy,
  setChooseAvatarOpen,
  setChooseHandleOpen,
  setWrongNetworkOpen,
  setZapOpen,
};
